export function formatExpenseOccurrenceForSubject(value) {
  if (value == null || value === '') return '';
  const text = String(value).trim();
  const monthMatch = text.match(/^(\d{4})-(\d{2})/);
  if (monthMatch) {
    return `${monthMatch[1]}年${Number(monthMatch[2])}月`;
  }
  return text.slice(0, 7);
}

/** 从 form_data 还原 ExpenseClaimForm 的 payee_ref（员工=工号，外部=payee_id） */
export function resolveExpensePayeeRefFromFormData(formData = {}) {
  const payeeType = formData.payee_type || 'employee';
  if (payeeType === 'employee') {
    return formData.employee_no || undefined;
  }
  return formData.payee_id || undefined;
}

export function buildExpenseClaimSubject({
  applicantDeptName,
  applicantName,
  expenseOccurrenceMonth,
  reason
}) {
  const occurrenceLabel = formatExpenseOccurrenceForSubject(expenseOccurrenceMonth);
  return `关于${applicantDeptName || ''}${applicantName || ''}报销${occurrenceLabel}${String(reason || '').trim()}费用`.trim();
}
